export const allConditionsSelector = (state) => {
    return state.medicalConditions?.MedicalConditions?.resultItems;
};
